import { memo } from 'react'
import { useSelector } from 'react-redux'

import { getLandingUtmSourceLinkUrl } from 'app/utils/links'
import { RaychatLogo } from 'app/components/icons'
import styles from './styles.module.scss'

const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

function LogoBar() {
  const languageInfo = useSelector(getLanguageInfo)

  //  use this to conditionally show sth instead of powered by raychat. just like once it used for black friday
  const shouldShowSecondBanner = false
  const linkUrl = getLandingUtmSourceLinkUrl(window.parent.location)

  const renderSecondBanner = <></>
  const renderRaychatLogoBar = (
    <a href={linkUrl} target="_blank" id="powerByImage" rel="noreferrer">
      {languageInfo.texts?.powered_by}
      <span className={styles.powered_by_logo_and_text_container}>
        <span className={styles.powered_by_text}>raychat</span>
        <RaychatLogo size={'17px 17px'} className={styles.powered_by_logo} />
      </span>
    </a>
  )
  const renderLogoBar = shouldShowSecondBanner ? renderSecondBanner : renderRaychatLogoBar

  return <div className={styles.main_powered_by_div}>{renderLogoBar}</div>
}

export default memo(LogoBar)
